import { ReactComponent as TidalColorLight } from 'fym-shared/src/music-services/assets/images/tidal-color-light.svg';
import { ReactComponent as TidalColorDark } from 'fym-shared/src/music-services/assets/images/tidal-color-dark.svg';
import { ReactComponent as TidalColorLightPadding } from 'fym-shared/src/music-services/assets/images/tidal-color-light-padding.svg';
import { ReactComponent as TidalColorDarkPadding } from 'fym-shared/src/music-services/assets/images/tidal-color-dark-padding.svg';
import { MusicServiceImages } from './types';

export const tidalImages: MusicServiceImages = {
  logoColor: {
    light: TidalColorLight,
    dark: TidalColorDark,
  },
  logoColorPadding: {
    light: TidalColorLightPadding,
    dark: TidalColorDarkPadding,
  },
};
